/**
 * Password hero waitlist — show success once after submit, clear on refresh
 * so another email can be entered.
 */
(function () {
  if (window.__cpPasswordWaitlistInit) return;
  window.__cpPasswordWaitlistInit = true;

  const FLAG_KEY = 'cp_password_waitlist_posted';
  const SUBMITTING = 'Joining…';

  function isPasswordWaitlistForm(form) {
    return form instanceof HTMLFormElement && form.hasAttribute('data-cp-password-waitlist');
  }

  function urlHadPostedParam() {
    try {
      const url = new URL(window.location.href);
      return url.searchParams.has('contact_posted') || url.searchParams.has('customer_posted');
    } catch {
      return false;
    }
  }

  function cleanPostedParams() {
    try {
      const url = new URL(window.location.href);
      let changed = false;

      ['contact_posted', 'customer_posted'].forEach(function (key) {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          changed = true;
        }
      });

      if (!changed) return;

      const query = url.searchParams.toString();
      const next = url.pathname + (query ? '?' + query : '') + url.hash;
      window.history.replaceState(null, '', next);
    } catch {
      /* ignore */
    }
  }

  function initSuccessState() {
    const form = document.querySelector('[data-cp-password-waitlist]');
    if (!isPasswordWaitlistForm(form)) {
      cleanPostedParams();
      return;
    }

    const thanks = form.querySelector('[data-cp-password-waitlist-thanks]');
    const fields = form.querySelector('[data-cp-password-waitlist-fields]');
    const postedOk = thanks instanceof HTMLElement;
    const fromRedirect = urlHadPostedParam();
    let fromFlag = false;

    try {
      if (sessionStorage.getItem(FLAG_KEY) === '1') {
        sessionStorage.removeItem(FLAG_KEY);
        fromFlag = true;
      }
    } catch {
      /* ignore */
    }

    // Only show success for this submit round-trip, not a later refresh.
    const showThanks = postedOk && (fromFlag || fromRedirect);

    if (thanks instanceof HTMLElement) {
      thanks.hidden = !showThanks;
    }

    if (fields instanceof HTMLElement) {
      fields.hidden = showThanks;
    }

    const email = form.querySelector('input[type="email"]');
    if (email instanceof HTMLInputElement && !showThanks) {
      email.value = '';
    }

    cleanPostedParams();
  }

  function handleSubmit(event) {
    const form = event.target;
    if (!isPasswordWaitlistForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn instanceof HTMLButtonElement) {
      submitBtn.disabled = true;
      submitBtn.dataset.cpOriginalLabel = submitBtn.textContent || '';
      submitBtn.textContent = form.getAttribute('data-submitting-label') || SUBMITTING;
    }

    function nativeSubmit() {
      try {
        sessionStorage.setItem(FLAG_KEY, '1');
      } catch {
        /* ignore */
      }
      form.submit();
    }

    const captcha = window.Shopify && window.Shopify.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(form, nativeSubmit);
      return;
    }

    nativeSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSuccessState);
  } else {
    initSuccessState();
  }

  document.addEventListener('submit', handleSubmit, true);
})();
